// extracted by mini-css-extract-plugin
export var figure = "styles-module--figure--3bU6b";
export var blockquote = "styles-module--blockquote--3eP8C";
export var autor = "styles-module--autor--wauTu";